import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/tailwind.css'
import './assets/css/progressloading.css'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import VueGoodTablePlugin from 'vue-good-table'
import * as svgicon from 'vue-svgicon'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import appInfo from './app-info'
import 'devextreme/dist/css/dx.common.css'
import 'devextreme/dist/css/dx.light.css'
import 'devextreme/dist/css/dx.material.blue.light.compact.css'
import Inputmask from 'inputmask'
import appsettings from './config.json'
import VueQuillEditor from 'vue-quill-editor'
import VueTimers from 'vue-timers'
import moment from 'moment'
import VueCompositionAPI from '@vue/composition-api'

Vue.use(VueCompositionAPI)

// app info
Vue.prototype.$appInfo = appInfo
Vue.prototype.$moment = moment

// for docs file only
Vue.prototype.$baseURL = appsettings.baseUrl.split('/api').join('')
// import the styles
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin)

Vue.use(axios)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

Vue.prototype.$axios = axios

// We install `vue-svgicon` as plugin
// and configure it to prefix all CSS
// classes with `AppIcon-`.
Vue.use(svgicon, {
  classPrefix: 'AppIcon-'
})

// vue leaflet js
Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

// loading screen
Vue.prototype.loading = function () {
  return this.$loading({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading'
  })
}

// Inputmask
Vue.directive('input-mask', {
  bind: function (el, binding) {
    var inputs = el.getElementsByTagName('INPUT')
    var input = inputs[0]
    if (inputs.length > 1) {
      input = inputs[inputs.length - 1]
    }
    new Inputmask(binding.value).mask(input)
  }
})

axios.interceptors.request.use(
  (config) => {
    // let token = localStorage.getItem('access_token')
    let token = Vue.$cookies.get('__auth')

    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  function (error) {
    if (error.response.status === 401) {
      store.dispatch('deleteToken')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

Vue.use(VueQuillEditor /* { default global options } */)

// Use VueTimers
Vue.use(VueTimers)

new Vue({
  router,
  axios,
  store,
  render: (h) => h(App)
}).$mount('#app')
